import { HttpMethod } from '@teqplay/api'

import { requestBuilder } from '../builder'

export type ISODateTimeString = string

export type EventType =
  | 'PORT_ATA'
  | 'PORT_ATD'
  | 'BREAKWATER_ATA'
  | 'BERTH_ATA'
  | 'BERTH_ATD'
  | 'PILOT_ONBOARD_ATA'
  | 'BUNKER_ALONGSIDE_START'
  | 'BUNKER_ALONGSIDE_END'

export type EventDetails = {
  /** Event type identifier */
  eventType: EventType
  /** Vessel IMO number */
  imo: string
  /** Vessel name */
  shipName: string
  /** Port ID */
  portId?: string
  /** Port name */
  portName: string
  /** ISO 8601 timestamp */
  timestamp: ISODateTimeString
  /** Optional other ship name involved in the event */
  otherShipName?: string | null
  /** Different than portId for berths/terminals/other internal infrastructure */
  locationId?: string | null
  /** Human-readable name for the location (berth/terminal/etc.) */
  locationName?: string | null
  /** Terminal name when applicable */
  terminalName?: string | null
}

/**
 * Input params for GET /v1/sof
 * - imo (required)
 * - portId (optional)
 * - unlocode (optional)
 */
export type TGetSofInput = {
  imo: string
  portId?: string
  unlocode?: string
}

/** Array of EventDetails */
export type TGetSofOutput = EventDetails[]

/**
 * GET /v1/sof
 * Retrieve Statement of Facts events for a vessel (optionally filtered by port).
 */
const get = requestBuilder
  .type<TGetSofInput, TGetSofOutput>()
  .request(({ input: { imo, portId, unlocode } }) => {
    // Basic parameter validation
    if (!imo || !imo.trim()) {
      throw new Error('Parameter "imo" is required')
    }

    const params = new URLSearchParams({ imo })
    if (portId && portId.trim()) params.set('portId', portId)
    if (unlocode && unlocode.trim()) params.set('unlocode', unlocode)

    return {
      path: `/v1/sof?${params.toString()}`,
      method: HttpMethod.GET
    }
  })

const sof = { get }
export default sof
